// Mercapoli - Sobre Nosotros
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ArrowLeft, Heart, Zap, Shield, Users, Target } from 'lucide-react';
import { Button } from '../../components/ui/button';
import Footer from '../../components/Footer';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_mercadelivery-1/artifacts/5y038jeg_icono_mercapoli.png";

const SobreNosotros = () => {
  const valores = [
    { icon: <Heart className="h-6 w-6" />, titulo: "Confianza", descripcion: "Construimos relaciones duraderas basadas en la transparencia" },
    { icon: <Zap className="h-6 w-6" />, titulo: "Rapidez", descripcion: "Optimizamos cada proceso para entregas más eficientes" },
    { icon: <Target className="h-6 w-6" />, titulo: "Innovación", descripcion: "Usamos tecnología de punta para mejorar constantemente" },
    { icon: <Shield className="h-6 w-6" />, titulo: "Transparencia", descripcion: "Información clara y accesible para todos" },
    { icon: <Users className="h-6 w-6" />, titulo: "Compromiso", descripcion: "Apoyamos el crecimiento de las comunidades locales" }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Sobre Nosotros | Mercapoli</title>
        <meta name="description" content="Mercapoli es una plataforma moderna de delivery que conecta comercios, repartidores y clientes con rapidez, seguridad y tecnología." />
      </Helmet>

      {/* Header */}
      <header className="border-b border-border">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img src={LOGO_URL} alt="Mercapoli" className="w-10 h-10" />
              <span className="font-heading text-xl font-bold">Mercapoli</span>
            </Link>
            <Link to="/">
              <Button variant="ghost" size="sm">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Volver
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Hero */}
      <section className="py-16 bg-gradient-to-b from-brand-primary/10 to-background">
        <div className="container mx-auto px-4 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold mb-6">
            Sobre Mercapoli
          </h1>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Plataforma moderna de delivery y logística
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="prose prose-lg dark:prose-invert mx-auto">
            <p className="text-lg leading-relaxed mb-8">
              <strong>Mercapoli</strong> es una plataforma tecnológica de delivery y logística diseñada para conectar 
              comercios, repartidores y clientes en un solo ecosistema eficiente, moderno y confiable.
            </p>

            <p className="text-lg leading-relaxed mb-8">
              Nuestra misión es facilitar entregas rápidas, seguras y accesibles, impulsando el crecimiento 
              de los comercios locales y creando oportunidades reales para repartidores independientes.
            </p>

            <p className="text-lg leading-relaxed mb-12">
              Nos apoyamos en tecnología, innovación y procesos inteligentes para optimizar cada entrega, 
              ofreciendo una experiencia confiable tanto para usuarios como para aliados comerciales.
            </p>
          </div>

          {/* Valores */}
          <div className="mt-16">
            <h2 className="font-heading text-2xl font-bold text-center mb-8">Nuestros Valores</h2>
            <div className="grid md:grid-cols-3 lg:grid-cols-5 gap-6">
              {valores.map((valor, index) => (
                <div key={index} className="text-center p-6 rounded-2xl bg-card border border-border">
                  <div className="w-12 h-12 mx-auto mb-4 rounded-xl bg-brand-primary/10 flex items-center justify-center text-brand-primary">
                    {valor.icon}
                  </div>
                  <h3 className="font-bold mb-2">{valor.titulo}</h3>
                  <p className="text-sm text-muted-foreground">{valor.descripcion}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Cierre */}
          <div className="mt-16 text-center py-12 bg-gradient-to-r from-brand-primary/10 via-brand-accent/10 to-brand-primary/10 rounded-3xl">
            <p className="text-2xl font-heading font-bold text-brand-primary">
              Mercapoli es movimiento, conexión y crecimiento.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default SobreNosotros;
